<template>
    <div>
        <h2>{{ $t("Rechnungsdaten") }}</h2>
        <Vueform v-model="model" ref="form" :schema="schema" :displayErrors="false"></Vueform>
    </div>
</template>

<script>
import {useStore} from "vuex";
export default {
    props: ['loginusername'],
    data: () => {
        return {
            model: {},
            schema: {},
            store: useStore(),
            person_fields: {
                firstname: {
                    attrs: { autofocus: true },
                    type: 'text',
                    floating: {de: 'Vorname', en: 'Name'},
                    placeholder: {de: 'Vorname', en: 'Name'},
                    rules: 'required',
                    columns: { container: 6, label: 12, wrapper: 12 }
                },
                lastname: {
                    type: "text",
                    floating: {de: 'Nachname', en: 'Surname'},
                    placeholder: {de: 'Nachname', en: 'Surname'},
                    rules: 'required',
                    columns: { container: 6, label: 12, wrapper: 12 }
                },
                email: {
                    type: "text",
                    inputType: 'email',
                    floating: 'E-Mail',
                    placeholder: 'E-Mail',
                    // `email` is the festiware validator from vueform.config.js; without it
                    // only the backend (StoreOrderRequest `required|email`) rejected the
                    // format, after submit and with a generic error (FWT-2809).
                    rules: 'required|email',
                    columns: { container: 6, label: 12, wrapper: 12 }
                },
                _hidden: {
                    type: "hidden",
                    columns: { container: 6, label: 12, wrapper: 12 }
                },
                address: {
                    type: "text",
                    floating: {de: 'Straße und Hausnummer', en: 'Street and house number'},
                    placeholder: {de: 'Straße und Hausnummer', en: 'Street and house number'},
                    rules: 'required',
                    columns: { container: 6, label: 12, wrapper: 12 }
                },
                zip: {
                    type: "text",
                    floating: {de: 'Postleitzahl', en: 'Zip'},
                    placeholder: {de: 'Postleitzahl', en: 'Zip'},
                    rules: 'required',
                    columns: { container: 3, label: 12, wrapper: 12 }
                },
                city: {
                    type: "text",
                    floating: {de: 'Stadt', en: 'City'},
                    placeholder: {de: 'Stadt', en: 'City'},
                    rules: 'required',
                    columns: { container: 3, label: 12, wrapper: 12 }
                },
                country: {
                    type: "select",
                    floating: {de: 'Land', en: 'Country'},
                    placeholder: {de: 'Land', en: 'Country'},
                    staticType: 'country',
                    search: true,
                    rules: 'required',
                    columns: { container: 6, label: 12, wrapper: 12 }
                },
            },
            company_fields: {
                company: {
                    type: 'text',
                    floating: {de: 'Firma', en: 'Company'},
                    placeholder: {de: 'Firma', en: 'Company'},
                    columns: { container: 6, label: 12, wrapper: 12 }
                },
                vat_id: {
                    type: 'text',
                    floating: {de: 'USt-Id', en: 'VAT ID'},
                    placeholder: {de: 'USt-Id', en: 'VAT ID'},
                    columns: { container: 6, label: 12, wrapper: 12 }
                },
            },
            // Reseller-POS: Käuferdaten sind komplett optional. Nur Format-Check
            // bei E-Mail (falls eingegeben), aber kein required mehr — Bar- und
            // Kartenterminal-Verkäufe dürfen anonym laufen. Adressfelder werden
            // sichtbar gerendert, damit der Kassierer Stammkunden-/Rechnungs-
            // daten direkt erfassen kann.
            with_login_user: {
                email: {
                    type: "text",
                    inputType: 'email',
                    floating: 'E-Mail',
                    placeholder: 'E-Mail',
                    rules: 'email',
                    columns: { container: 12, label: 12, wrapper: 12 }
                },
                firstname: {
                    type: 'text',
                    floating: {de: 'Vorname (optional)', en: 'First name (optional)'},
                    placeholder: {de: 'Vorname', en: 'First name'},
                    columns: { container: 6, label: 12, wrapper: 12 }
                },
                lastname: {
                    type: 'text',
                    floating: {de: 'Nachname (optional)', en: 'Surname (optional)'},
                    placeholder: {de: 'Nachname', en: 'Surname'},
                    columns: { container: 6, label: 12, wrapper: 12 }
                },
                company: {
                    type: 'text',
                    floating: {de: 'Firma (optional)', en: 'Company (optional)'},
                    placeholder: {de: 'Firma', en: 'Company'},
                    columns: { container: 6, label: 12, wrapper: 12 }
                },
                vat_id: {
                    type: 'text',
                    floating: {de: 'USt-Id (optional)', en: 'VAT ID (optional)'},
                    placeholder: {de: 'USt-Id', en: 'VAT ID'},
                    columns: { container: 6, label: 12, wrapper: 12 }
                },
                address: {
                    type: 'text',
                    floating: {de: 'Straße und Hausnummer (optional)', en: 'Street and house number (optional)'},
                    placeholder: {de: 'Straße und Hausnummer', en: 'Street and house number'},
                    columns: { container: 12, label: 12, wrapper: 12 }
                },
                zip: {
                    type: 'text',
                    floating: {de: 'PLZ (optional)', en: 'Zip (optional)'},
                    placeholder: {de: 'PLZ', en: 'Zip'},
                    columns: { container: 3, label: 12, wrapper: 12 }
                },
                city: {
                    type: 'text',
                    floating: {de: 'Stadt (optional)', en: 'City (optional)'},
                    placeholder: {de: 'Stadt', en: 'City'},
                    columns: { container: 3, label: 12, wrapper: 12 }
                },
                country: {
                    type: 'select',
                    floating: {de: 'Land (optional)', en: 'Country (optional)'},
                    placeholder: {de: 'Land', en: 'Country'},
                    staticType: 'country',
                    search: true,
                    columns: { container: 6, label: 12, wrapper: 12 }
                },
                "send-ticket-to-client": {
                    type: 'checkbox',
                    text: {de: "Ticket direkt an Käufer:In schicken", en: 'Send ticket directly to buyer'},
                    columns: { container: 12, label: 12, wrapper: 12 },
                    // Nur aktivierbar, wenn eine Email-Adresse erfasst wurde — sonst gibt es niemanden, an den gesendet werden könnte.
                    conditions: [
                        ['email', '!=', '']
                    ],
                }
            }
        };
    },
    mounted() {
        this.schema = this.loginusername ? this.with_login_user : { ...(this.store.state.withCompany ? this.company_fields : {}), ...this.person_fields};
        this.$nextTick(() => {
            this.$refs.form.update(this.store.state.personData ? this.store.state.personData : {})
        })
    },
    watch: {
        // The payment tiles below depend on the country, and personData only
        // reaches the store on validate().
        'model.country': {
            handler(country) {
                this.store.state.billingCountry = country || '';
            },
            immediate: true,
        },
    },
    methods: {
        validate() {
            return new Promise(resolve => {
                this.store.state.personData = this.model;
                this.$refs.form.validate().then(() => {
                    const isInvalid = this.$refs.form.invalid;
                    if (isInvalid) {
                        this.store.commit('emitScroll');
                    }
                    resolve(!isInvalid);
                })
            })
        }
    },
};
</script>
